/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M9 6a.75.75 0 0 0 0 1.5h11A.75.75 0 0 0 20 6H9ZM4.75 7.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 11.75A.75.75 0 0 1 9 11h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM5.5 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9 16a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5H9ZM4.75 17.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 4c0-1.6568 1.3432-3 3-3h18c1.6569 0 3 1.3432 3 3v16c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3V4Zm3-1.5h18c.8284 0 1.5.6716 1.5 1.5v16c0 .8284-.6716 1.5-1.5 1.5H3c-.8284 0-1.5-.6716-1.5-1.5V4c0-.8284.6716-1.5 1.5-1.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'ShowLogs'
);
